import { appendIf } from '@btime/helpers'
import { assoc, compose, pathOr, pick, prop } from 'ramda'
import { gql, useMutation } from '@apollo/client'

import { fieldsClient } from '../../../../utils/apollo/api'
import { useCloseModal, useModalData } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertFields($inputs: [FieldsInput]) {
    upsertFields(inputs: $inputs) {
      id
    }
  }
`

const cleanQuestionOptions = question =>
  assoc(
    'options',
    (question.options || []).filter(prop('name')).map(
      (option, index) =>
        compose(
          assoc('ordination', index), //
          pick(['id', 'name', 'reference', 'ordination'])
        )(option),
      question
    ),
    question
  )

const cleanRequest = (fields, origin) =>
  fields.map((field, index) =>
    compose(
      pick([
        'id',
        'name',
        'origin',
        'ordination',
        'type',
        'deleted',
        'required',
        'maskIds',
        'configuration',
        'options'
      ]), //
      assoc('deleted', !!field.deleted),
      assoc('origin', origin),
      assoc('ordination', index),
      item => assoc('configuration', item.configuration ? JSON.stringify(item.configuration) : null, item),
      question => {
        const masks = pathOr([], ['masks'], question)
        return assoc('maskIds', [...(!Array.isArray(masks) ? [masks] : masks)]?.map(prop('id')), question)
      },
      cleanQuestionOptions
    )(field)
  )

const validate = (form, setErrors) => {
  const errors = form.reduce(
    (errors, item, index) => [
      ...errors,
      ...appendIf(!item.name, { path: [index, 'name'], message: 'Campo obrigatório' })
    ],
    []
  )

  setErrors(errors)
  return errors.length === 0
}

export const useSaveFields = () => {
  const closeModal = useCloseModal()
  const origin = useModalData()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Fields'], client: fieldsClient })

  const handleRequest = (form, actions) => {
    const inputs = cleanRequest(form, origin)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { inputs } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
